/**
 * `pattern.railProgressLine` (tokens.json / objective-detail.md SS1.2) — the
 * single continuous progress bar for the objective detail screen. Explicitly
 * NOT a segmented block grid (bug fix carried from the spec). Fill is always
 * hue.primary.vivid (theme-level), never a category accent — this screen is
 * about an objective, not a category.
 */
export function RailProgressLine({
  done,
  total,
}: {
  readonly done: number;
  readonly total: number;
}) {
  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div
      role="img"
      aria-label={`${done} of ${total} modules complete`}
      style={{
        height: 'var(--pattern-rail-line-height)',
        background: 'var(--border-subtle)',
        borderRadius: 'var(--radius-pill)',
        marginTop: 'var(--space-3)',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          height: '100%',
          width: `${percent}%`,
          background: 'var(--hue-primary-vivid)',
          borderRadius: 'var(--radius-pill)',
          transition: 'width var(--dur-counter) var(--ease-standard)',
        }}
      />
    </div>
  );
}
